import {
    ButtonPrimary,
    ButtonFixedFooterLayout,
    Text3,
    Text2,
    Text6,
    IconChevronLeftRegular,
    NavigationBar,
    skinVars,
    IconShieldCrossRegular,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';
import navigateParams from '../../../../../utils/navigation/navigateParams';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { sendEscalationOTP } from '../../../../../services/EscalationService';
import { setInfoError } from '../../../../../utils/dataTransformation/errorMesssages';
import { isBrowser } from 'react-device-detect';
import { TrackingEvents } from '../../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../utils/navigation/controlDevices';
import {
    hideMobileCharacters,
    hideEmailCharacters,
    formatMobileNumber,
} from '../../../../../utils/dataTransformation/unitsConversion';

const ContactInfoVerified2: React.FC = () => {
    const { t } = useTranslation();
    const [params] = useSearchParams();
    const contact = params.get('contact')!;
    const type = params.get('type')!;
    const { trackingScreenView } = new TrackingEvents();
    const navigate = useNavigate();
    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);

    const sendToNative = (url: string, description: string, type: string, title?: string, err?: any) => {
        const storage = {};
        const feedbackData = {
            err: err,
        };
        const queryParams = {
            state: description,
            errorCode: err ? err.id : '',
            contact: contact,
        };
        if (type === 'feedback-error') {
            if (navigateParams(type, url, queryParams, storage, title)) {
                navigate(url, { state: feedbackData });
            }
        } else {
            if (navigateParams(type, url, queryParams, storage, title)) {
                navigate(url + '?contact=' + contact);
            }
        }
    };

    const escalationOTPSend = () => {
        const data: any = { contact: contact };
        sendEscalationOTP(data)
            .then(() => {
                sendToNative(
                    '/escalation/otp/verify',
                    '',
                    'modeFlow-backgroundBlue',
                    type === 'mobile' ? 'Verificar móvil de contacto' : 'Verificar dirección de email',
                );
            })
            .catch((error: any) => {
                sendToNative('/escalation/otp/feedback', 'ERROR', 'feedback-error', '', setInfoError(error));
            });
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (windowWidth >= 1024) {
        return (
            <div className='desktop-contact-info-verified'>
                <div className='desktop-contact-info-verified__header-navigationBar'>
                    <NavigationBar isInverse={true} title={''} />
                </div>
                <div className='desktop-contact-info-verified__left'>
                    <div className='desktop-contact-info-verified__left__icon'>
                        <IconShieldCrossRegular size={64} color={skinVars.colors.brand}></IconShieldCrossRegular>
                    </div>
                    <div className='desktop-contact-info-verified__left__title'>
                        <Text6 color={skinVars.colors.textPrimary}>{t('otpFlowTitle')}</Text6>
                    </div>
                    <div className='desktop-contact-info-verified__left__subtitle'>
                        <Text3 regular color={skinVars.colors.textSecondary}>
                            {t('otpFlowSubtitle')}
                        </Text3>
                    </div>
                </div>
                <div className='desktop-contact-info-verified__right'>
                    <div className='contact-info-verified2'>
                        <div className='contact-info-verified2__header-return'>
                            <div
                                className='contact-info-verified2__header-return-icon'
                                onClick={() => {
                                    navigate(-1);
                                }}
                            >
                                <IconChevronLeftRegular color={skinVars.colors.textLink} size={20} />
                            </div>
                            <Text2 medium color={skinVars.colors.textLink}>
                                {t('returnResponsive')}
                            </Text2>
                        </div>

                        <div className='contact-info-verified2__title'>
                            <Text3 regular color={skinVars.colors.textPrimary}>
                                {t('contactVerifiedTitleStep1')}
                            </Text3>
                        </div>
                        <div className='contact-info-verified2__text1'>
                            <Text2 regular color={skinVars.colors.textSecondary}>
                                {type === 'mobile' ? t('contactVerifiedMobile') : t('contactVerifiedEmail')}
                            </Text2>
                        </div>
                        <div className='contact-info-verified2__text2'>
                            <Text2 regular color={skinVars.colors.textSecondary}>
                                {type === 'mobile'
                                    ? formatMobileNumber(hideMobileCharacters(contact))
                                    : hideEmailCharacters(contact)}
                            </Text2>
                        </div>
                        <div className='contact-info-verified2__buttonPrimary'>
                            <ButtonPrimary
                                onPress={() => {
                                    escalationOTPSend();
                                }}
                            >
                                {t('next')}
                            </ButtonPrimary>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className='contact-info-verified2'>
                <ButtonFixedFooterLayout
                    button={
                        <ButtonPrimary
                            onPress={() => {
                                escalationOTPSend();
                            }}
                        >
                            {t('next')}
                        </ButtonPrimary>
                    }
                >
                    {isBrowser && (
                        <div className='c-customer-agreement-navigationBar'>
                            <NavigationBar
                                isInverse={true}
                                onBack={() => {
                                    navigate(-1);
                                }}
                                title={'Verificar móvil de contacto'}
                            />
                        </div>
                    )}
                    <div className='contact-info-verified2__title'>
                        <Text3 regular color={skinVars.colors.textPrimary}>
                            {t('contactVerifiedTitleStep1')}
                        </Text3>
                    </div>
                    <div className='contact-info-verified2__text1'>
                        <Text2 regular color={skinVars.colors.textSecondary}>
                            {type === 'mobile' ? t('contactVerifiedMobile') : t('contactVerifiedEmail')}
                        </Text2>
                    </div>
                    <div className='contact-info-verified2__text2'>
                        <Text2 regular color={skinVars.colors.textSecondary}>
                            {type === 'mobile' ? hideMobileCharacters(contact) : hideEmailCharacters(contact)}
                        </Text2>
                    </div>
                </ButtonFixedFooterLayout>
            </div>
        );
    }
};

export default ContactInfoVerified2;
